module.exports = __webpack_public_path__ + "static/media/benefit-easy@3x.c10fe982.png";